import { render, staticRenderFns } from "./seller-1.vue?vue&type=template&id=1b395667"
import script from "./seller-1.vue?vue&type=script&lang=js"
export * from "./seller-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports